import { defaultTo } from 'ramda';

import { useApplicationContext } from 'shared/containers/ApplicationContext';

import type { TSlide } from '@cian/frontend-newbuilding-promo-modal-widget/es/components/SliderModal/types/slide';

export const usePurchaseMethodsInfo = (): TSlide[] | undefined => {
  const { config } = useApplicationContext();

  return defaultTo(undefined, config.get('purchaseMethodsInfo'));
};
